// LIBRARIES
import styled from "styled-components";

// MISC
import { COLORS, DEVICE_TYPE, MARGIN, SIZE } from "../../constants/variables";

export const Circle = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.active ? COLORS.VividAuburn : COLORS.MetalicSilver};
`;

export const SliderWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: ${SIZE.max60} 0;
  width: 100vw;
  position: relative;
  height: 32vh;
  @media (max-width: ${DEVICE_TYPE.mediumDesktop}) {
    height: auto;
  }
`;
export const CenterWrapper = styled.div`
  width: 100%;
  height: auto;
`;
